import React, { useEffect, useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useUtility } from '../useUtility';
import { useRoles } from '../../../customHooks/useRoles';
import { useTheme } from '@emotion/react';
import RoleColumns from './_columns';
import Spinner from '../../../../components/utils/spinner';
import Pagination from './pagination';
import RolesListDisplayHeader from './rolesListDisplayHeader';
import PermissionsModal from '../permissionsModal/permissionsModal';

const RolesListDisplay = ({ setOpen }) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const { rolesList, loading, pagedList, meta, keyword, setKeyword } =
    useRoles();
  const [list, setList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [bulkAction, setBulkAction] = useState('');
  const { isPermissionModalOpen, handleClosePermissionModal } = useUtility();
  const permissionsData = JSON.parse(
    localStorage.getItem('tenantdata')
  ).tenant_nav_bar_permission;
  const { tenant_permissions, genral_permissions, user_permission } =
    permissionsData;
  function getPermissionByModuleName(module_name) {
    return (
      user_permission.find(
        (permission) => permission.module_name === module_name
      ) || null
    );
  }
  const permissions = getPermissionByModuleName('is_roles_tab');

  // useEffect(() => {
  //   if (keyword === '') {
  //     setList(pagedList);
  //     return;
  //   }
  //   let rows = rolesList.filter((item) =>
  //     item['name'].toString().toLowerCase().includes(keyword.toLowerCase())
  //   );
  //   setList(rows);
  // }, [keyword]);

  useEffect(() => {
    setList(pagedList);
  }, [pagedList]);

  const handleSelectedRowsChange = (selectionModel) => {
    let selectRowArray = [];
    selectionModel.forEach((rowID) => {
      const selectRow = list.find((row) => row.id === rowID);
      selectRowArray.push(selectRow);
    });
    setSelectedRows(selectRowArray);
  };
  return (
    <>
      {loading ? (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spinner />
        </Box>
      ) : (
        <Box
          boxShadow={4}
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            borderRadius: '15px',
          }}
        >
          <PermissionsModal
            open={isPermissionModalOpen}
            handleClose={handleClosePermissionModal}
            list={list}
          />
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              padding: '20px',
              boxSizing: 'border-box',
            }}
          >
            <RolesListDisplayHeader
              keyword={keyword}
              setKeyword={setKeyword}
              bulkAction={bulkAction}
              setBulkAction={setBulkAction}
              bulkId={selectedRows}
              permissions={permissions}
              setOpen={setOpen}
              list={list}
            />

            <DataGrid
              rows={list}
              columns={RoleColumns}
              hideFooter
              disableColumnFilter
              disableColumnSelector
              onRowSelectionModelChange={handleSelectedRowsChange}
              autoPageSize={true}
              sx={{
                width: '100%',
                border: 'none',
                '& .MuiDataGrid-withBorderColor': {
                  border: 'none',
                },
                '& .column-cell': {
                  margin: '0% auto',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '100%',
                  borderBottom: '1px solid white',
                },
                '& .header-cell': {
                  fontSize: '18px',
                  fontWeight: 'bold',

                  borderBottom: '3px solid white',
                },
                '& .action-cell': {
                  fontSize: '18px',
                  fontWeight: 'bold',

                  paddingRight: {
                    lg: '2.7rem',
                    md: '2.5rem',
                    sm: '2.8rem',
                    xs: '2rem',
                    xl: '3rem',
                  },
                  borderBottom: '3px solid white',
                },
                '& .css-t89xny-MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 'normal',
                },
                '& .MuiDataGrid-cell:focus': {
                  outline: 'none',
                },
                '& .MuiDataGrid-columnHeader:focus': {
                  outline: 'none',
                },
                '--unstable_DataGrid-radius': 'none',
                borderTop: '1px solid white',
              }}
            />
            <Box
              sx={{
                m: 'auto',
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                py: 0.5,
                mt: 0.4,
              }}
            >
              <span>
                {' '}
                Showing {meta.from ?? 0} to {meta.to ?? 0} of {''}
                {meta.total} entries
              </span>
              <Pagination />
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default RolesListDisplay;
